import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import ReportAddForm from '../../containers/ReportAddForm/ReportAddForm';

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit,
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const ReportAddPage = ({ classes, match }) => {
  const userId = parseInt(match.params.userId, 10);
  const props = {};

  if (!Number.isNaN(userId)) {
    props.userId = userId;
  }

  return (
    <div>
      <Paper className={classes.paper}>
        <ReportAddForm {...props} />
      </Paper>
    </div>
  );
};

ReportAddPage.propTypes = propTypes;
export default withStyles(styles, { withTheme: true })(ReportAddPage);



// WEBPACK FOOTER //
// ./src/pages/Reports/Add.js